// =====================================================
// 📁 POSProcessPendingCashierSaleModal.tsx
// =====================================================

import FormModal from '../../../Modals/FormModal';

import { useSale } from '../../../../hooks/sale/useSale';

import POSSummaryTotals from '../summary/POSSummaryTotals';

import POSPaymentCondition from '../summary/POSPaymentCondition';

import POSPaymentMethods from '../summary/POSPaymentMethods';

import POSFinalizeButton from '../summary/POSFinalizeButton';

import POSSelectedProducts from '../summary/POSSelectedProducts';

import POSGlobalDiscountSection from '../summary/POSGlobalDiscountSection';

interface Props {
  isOpen: boolean;

  onClose: () => void;
}

const POSProcessPendingCashierSaleModal = ({ isOpen, onClose }: Props) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { form } = useSale();

  // ⚠️ Leer form.paymentCondition.code, no el paymentConditionCode suelto de
  // Redux (queda desincronizado al recargar la venta desde el servidor).
  const isOtherCondition = form?.paymentCondition?.code === 'OTRO';

  // =====================================================
  // 🔹 Helpers
  // =====================================================

  const products = form?.products || [];

  const productsCount = products.length;

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Procesar Cobro"
      maxWidth="max-w-5xl"
      overlayBg="black"
    >
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}

      <div
        className="
          mb-6

          flex
          flex-col
          gap-4

          rounded-2xl

          border
          border-stroke

          bg-slate-50

          p-5

          dark:border-strokedark
          dark:bg-meta-4

          lg:flex-row
          lg:items-center
          lg:justify-between
        "
      >
        <div>
          <p
            className="
              text-xs
              text-slate-500
            "
          >
            Documento
          </p>

          <h2
            className="
              mt-1

              text-xl
              font-bold
              text-black

              dark:text-white
            "
          >
            {form?.documentNumber}
          </h2>

          <p
            className="
              mt-1

              text-sm
              text-slate-500
            "
          >
            {form?.customer?.name}
          </p>
        </div>

        <div
          className="
            text-left

            lg:text-right
          "
        >
          <p
            className="
              text-xs
              text-slate-500
            "
          >
            Total Venta
          </p>

          <h1
            className="
              text-4xl
              font-black
              text-primary
            "
          >
            ${form?.totals?.totalToPay?.toFixed(2)}
          </h1>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Layout */}
      {/* ===================================================== */}

      <div
        className="
          grid
          grid-cols-1
          gap-6

          xl:grid-cols-12
        "
      >
        {/* ===================================================== */}
        {/* 🔹 Left */}
        {/* ===================================================== */}

        <div
          className="
            xl:col-span-7
          "
        >
          <div
            className="
              rounded-2xl

              border
              border-stroke

              bg-white

              p-5

              dark:border-strokedark
              dark:bg-boxdark
            "
          >
            {/* 🔹 Products */}
            <div
              className="
                mb-5

                flex
                items-center
                justify-between
              "
            >
              <div>
                <h3
                  className="
                    text-lg
                    font-semibold
                    text-black

                    dark:text-white
                  "
                >
                  Productos
                </h3>

                <p
                  className="
                    mt-1

                    text-sm
                    text-slate-500
                  "
                >
                  {productsCount} productos en la venta
                </p>
              </div>
            </div>

            <POSSelectedProducts />
          </div>
        </div>

        {/* ===================================================== */}
        {/* 🔹 Right */}
        {/* ===================================================== */}

        <div
          className="
            xl:col-span-5
          "
        >
          <div
            className="
              rounded-2xl

              border
              border-stroke

              bg-white

              p-5

              dark:border-strokedark
              dark:bg-boxdark
            "
          >
            {/* 🔹 Totals */}
            <POSSummaryTotals />

            {/* 🔹 Discount */}
            <POSGlobalDiscountSection />

            {/* 🔹 Payment Condition */}
            <POSPaymentCondition />

            {/* 🔹 Payment Methods */}
            {!isOtherCondition && <POSPaymentMethods />}

            {/* 🔹 Finalize */}
            <div className="mt-6">
              <POSFinalizeButton />
            </div>
          </div>
        </div>
      </div>
    </FormModal>
  );
};

export default POSProcessPendingCashierSaleModal;
